var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.57143V2C14 1.72386 13.7761 1.5 13.5 1.5H1.5C1.22386 1.5 1 1.72386 1 2V20C1 20.2761 1.22386 20.5 1.5 20.5H13.5C13.7761 20.5 14 20.2761 14 20V16.4286",
    stroke: "#828A9A",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.26953,
    y: 9.9823,
    width: 10.8571,
    height: 2,
    fill: "#828A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6465 7.4137L21.0137 11.0001L17.6465 14.5865",
    stroke: "#828A9A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon_exit.c16e532cf90cc977be1df429c6a008d9.svg";
export { ForwardRef as ReactComponent };